// Request util for api call
import request from '~/utils/request';

// Actions
import {
  SET_CUSTOM_FIELDS_CATALOG_DATA,
  SET_CUSTOM_FIELDS_DATA,
  SET_CUSTOM_FIELDS_LOADER,
} from './action-types';

const fetchCustomFieldTypes = () => async () => {
  try {
    const response = await request.get('custom-fields/types');
    return response;
  } catch (error) {
    return error.response;
  }
};

const fetchCustomFields = (payload) => async (dispatch) => {
  try {
    dispatch({ type: SET_CUSTOM_FIELDS_LOADER, payload: true });
    const customFields = await request.get('custom-fields/get', payload);
    if (customFields?.data?.data) {
      dispatch({ type: SET_CUSTOM_FIELDS_DATA, payload: customFields.data.data });
    }
    return customFields;
  } catch (error) {
    return error.response;
  } finally {
    dispatch({ type: SET_CUSTOM_FIELDS_LOADER, payload: false });
  }
};

const fetchAllCustomFields = (payload) => async () => {
  try {
    const customFields = await request.get('custom-fields', payload);
    return customFields;
  } catch (error) {
    return error.response;
  }
};

const fetchCustomFieldsCatalog = () => async (dispatch) => {
  try {
    const pagination = { page: 1, pageSize: 500 };
    const customFields = await request.get('custom-fields/get', pagination);

    dispatch({
      type: SET_CUSTOM_FIELDS_CATALOG_DATA,
      payload: customFields.data.data?.rows || [],
    });
    return customFields;
  } catch (error) {
    return error.response;
  }
};

const fetchCustomFieldsForDesignerQuery = (payload) => async () => {
  try {
    const customFields = await request.get('custom-fields/get', payload);
    return customFields;
  } catch (error) {
    return error.response;
  }
};

const createCustomField = (payload, pagination) => async (dispatch) => {
  try {
    const customField = await request.post('custom-fields', payload);
    dispatch(fetchCustomFields(pagination));
    dispatch(fetchCustomFieldsCatalog());
    return customField;
  } catch (error) {
    return error.response;
  }
};

const updateCustomField = (id, payload, pagination) => async (dispatch) => {
  try {
    const updatedCustomField = await request.put(`custom-fields/${id}`, payload);
    dispatch(fetchCustomFields(pagination));
    dispatch(fetchCustomFieldsCatalog());
    return updatedCustomField;
  } catch (error) {
    return error.response;
  }
};

const deleteCustomField = (id, pagination) => async (dispatch) => {
  try {
    const deletedCustomField = await request.delete(`custom-fields/${id}`);
    dispatch(fetchCustomFields(pagination));
    dispatch(fetchCustomFieldsCatalog());
    return deletedCustomField;
  } catch (error) {
    return error.response;
  }
};

export {
  fetchCustomFields,
  fetchCustomFieldTypes,
  createCustomField,
  deleteCustomField,
  updateCustomField,
  fetchAllCustomFields,
  fetchCustomFieldsForDesignerQuery,
  fetchCustomFieldsCatalog,
};
